module.exports = __webpack_public_path__ + "static/media/talent.2d41e288.svg";